import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi'
import { z } from 'zod'

extendZodWithOpenApi(z)

/**
 * The `kind` of the unmarked member of a union split on `kind`. A discriminated union needs a literal on
 * every member, and only an optional one routes a value saved without `kind` to this member alone.
 *
 * Published as a field no value satisfies: zod's own rendering of an `undefined` literal publishes `null`,
 * which this schema refuses.
 */
export const UnmarkedKindSchema = z.literal(undefined).optional().openapi({ type: 'string', enum: [] })
